
export default (value, min, max) => {
  return Math.floor(Math.min(Math.max(value, min), max))
}
